import { Stack, Chip, Box } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { uniqBy } from 'es-toolkit';
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { DropzoneRoot, NoFiles } from '../../../styled/ChangeRequest.styled';
import { getFileName } from '../../../utils/getFileName';

interface DocumentDropzoneProps extends GridRenderEditCellParams {}

const DocumentDropzone = ({ id, field, value }: DocumentDropzoneProps) => {
  const apiRef = useGridApiContext();

  const [files, setFiles] = useState<(string | File)[]>(value || []);

  const onDrop = (acceptedFiles: File[]) => {
    setFiles((prevFiles) => {
      const allFiles = uniqBy([...prevFiles, ...acceptedFiles], (file) =>
        typeof file === 'string' ? getFileName(file) : file.name,
      );

      return allFiles;
    });
  };

  const handleDelete = (fileToDelete: string | File) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  useEffect(() => {
    apiRef.current.setEditCellValue({
      id,
      field,
      value: files,
    });
  }, [files]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const renderFileChip = (file: string | File, index: number) => (
    <Box key={index}>
      {typeof file === 'string' ? (
        <Chip label={getFileName(file)} onDelete={() => handleDelete(file)} />
      ) : (
        <Chip label={file.name} onDelete={() => handleDelete(file)} />
      )}
    </Box>
  );

  return (
    <DropzoneRoot {...getRootProps()} isDragActive={isDragActive}>
      <input {...getInputProps()} />
      <Stack gap={1}>{files.map(renderFileChip)}</Stack>
      {files.length === 0 && (
        <NoFiles>
          <CloudUploadIcon color="primary" />
        </NoFiles>
      )}
    </DropzoneRoot>
  );
};

export default DocumentDropzone;
